import React from 'react';
import Modal from '@roo/roo/Modal';
import placeholderReplace from '@utils/placeholderReplace';
import TimeCounter, {
    convertSecondsToTimeStrShortWithNoZeroHour,
} from '@business/components/TimeCounter';
import { getGrayStateByToken, GRAY_AB_TOKEN } from '@utils/grayAB';
import styles from './RefundUrgeModal.module.scss';

const openRefundUrgeModal = ({
    title,
    tips,
    /** {#orderDateAndSeq}号订单顾客催促您尽快审核退款，请在{#agreeRefundDeadlineTime}内处理 */
    template,
    orderDateAndSeq,
    agreeRefundDeadlineTime,
    wmOrderViewId,
}: {
    title: string;
    tips: string;
    template: string;
    orderDateAndSeq: string;
    agreeRefundDeadlineTime: number;
    wmOrderViewId: string;
}) => {
    Modal.confirm({
        title,
        children: (
            <>
                <div className={styles.content}>
                    {placeholderReplace(template, {
                        '{#orderDateAndSeq}': segment => (
                            <span key={segment} className={styles.highlight}>
                                {orderDateAndSeq}
                            </span>
                        ),
                        '{#agreeRefundDeadlineTime}': segment => {
                            const now = Math.floor(Date.now() / 1000);
                            return agreeRefundDeadlineTime >= now ? (
                                <span key={segment} className={styles.highlight}>
                                    <TimeCounter
                                        countType="down"
                                        startTime={agreeRefundDeadlineTime - now}
                                        format={convertSecondsToTimeStrShortWithNoZeroHour}
                                    />
                                </span>
                            ) : (
                                <span key={segment} className={styles.highlight}>
                                    00:00
                                </span>
                            );
                        },
                    })}
                </div>
                <div className={styles.tips}>{tips}</div>
            </>
        ),
        closable: true,
        cancelText: '我知道了',
        confirmText: '立即查看',
        onConfirm: () => {
            window.location.hash = getGrayStateByToken(GRAY_AB_TOKEN.UNIFIED_ORDER)
                ? `/new_fe/orderbusiness#/order/search?searchItem=${wmOrderViewId}`
                : `/new_fe/business#/order/search?searchItem=${wmOrderViewId}`;
        },
        className: styles.refundUrgeModal,
    });
};

export default openRefundUrgeModal;
